import { isObjectRecord } from "../typeGuards/isObjectRecord";
import type { ArsListingRow } from "./interface";

/**
 * Type guard for ArsListing row definitions.
 *
 * @param obj - Unknown value to validate
 * @returns True when value can be treated as ArsListingRow
 */
export const isArsListingRow = (obj: unknown): obj is ArsListingRow => {
  // Check object
  if (!isObjectRecord(obj)) return false;

  // Check required properties
  if (typeof obj.id !== "string") return false;
  if (typeof obj.rowHeight !== "number") return false;
  if (typeof obj.ellipsis !== "boolean") return false;
  // Everything is good
  return true;
};
